import Vue from 'vue'
import Router from 'vue-router'
import ForecastMain from '@/components/ForecastMain'
import About from '@/components/About'
import Info from '@/components/Info'
import "@/assets/css/margin.css"

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'ForecastMain', component: ForecastMain},
    { path: "/places/:place", name: 'ForecastMain', component: ForecastMain},
    { path: "/about", name: 'About', component: About},
    { path: "/info", name: 'Info', component: Info}
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.name == "About" || from.name == "About") {
      return { x: 0, y: 0 };
    } else {
      return false
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js